import { forwardRef, type InputHTMLAttributes, type ReactNode } from 'react';

import { CheckableInput } from './CheckableInput';

type Props = InputHTMLAttributes<HTMLInputElement> & {
  label: ReactNode;
};

export const RadioButton = forwardRef<HTMLInputElement, Props>((props, ref) => {
  return <CheckableInput type="radio" ref={ref} {...props} />;
});

RadioButton.displayName = 'RadioButton';
